import { vidMap } from './rep-fin-data-grouping';
import './rep-fin-report-detail.css';
import { Table, Button, Typography, Collapse } from 'antd';
import { useExcelData } from "../rep-excel-data-provider";
import { useEffect, useMemo } from 'react';

  const { Title } = Typography;
  const { Panel } = Collapse;
// Фильтрация по типу итогов: приход и возврат
function getTotal(items, detailType) {
  if (detailType === 'total') {
    return items.reduce((sum, item) => {
      const put = item.symaPut || 0;
      const exp = item.symaExp || 0;
      return sum + (put - exp);
    }, 0);
  }

  const key = detailType === 'exp' ? 'symaExp' : 'symaPut';
  return items.reduce((sum, item) => {
    const value = item[key];
    return value && value !== 0 ? sum + value : sum;
  }, 0);
}

// Таблица детализации по ячейке из общей таблицы
function DetailTable({ items, detailType, detailParams }) {
  const { setExcelData } = useExcelData();

  const columns = useMemo(() => {
    return [
      {
        title: "Тип покупки",
        dataIndex: "vid",
        key: "vid",
        render: (vid) => vidMap[vid] || vid,
      },
      {
        title: "Клиент",
        dataIndex: "clientName",
        key: "clientName",
        render: (name) => name || "Не указан",
      },
      {
        title: "Название",
        dataIndex: "tovName",
        key: "tovName",
        render: (name, row) => name || row.description || "Не указано",
      },
      {
        title: detailType === "exp" ? "Возврат" : "Сумма",
        key: "sum",
        align: "right",
        render: (_, row) => {
          if (detailType === "total") {
            const put = row.symaPut || 0;
            const exp = row.symaExp || 0;
            const diff = put - exp;
            return diff !== 0 ? diff.toLocaleString() : "";
          }
          const val = row[detailType === "exp" ? "symaExp" : "symaPut"];
          return val ? val.toLocaleString() : "";
        },
      },
    ];
  }, [detailType]);

  const filtered = useMemo(() => {
    if (!items?.length) return [];
    if (detailType === "total") {
      return items.filter(
        (item) => (item.symaPut || 0) !== 0 || (item.symaExp || 0) !== 0
      );
    }
    const key = detailType === "exp" ? "symaExp" : "symaPut";
    return items.filter((item) => item[key] && item[key] !== 0);
  }, [items, detailType]);

  const { vidName = "Отчет" } = detailParams || {};
  const total = useMemo(() => getTotal(items, detailType), [items, detailType]);

  console.log(total)
  // Передача данных в Excel контекст
    useEffect(() => {
    if (!filtered.length) return;
    const label =
      detailType === "total"
        ? "Итог"
        : detailType === "exp"
        ? "Возвраты"
        : "Продажи";

    setExcelData({
      title: `${vidName} - ${label}`,
      columns,
      data: filtered,
      summary: [
        ['', '', 'Итого по группе:', total]
      ]
    });

    return () => setExcelData(null);
  }, [filtered, columns, detailType, setExcelData, vidName, total]);

  if (filtered.length === 0) return null;

  return (
    <Table
      columns={columns}
      dataSource={filtered}
      pagination={false}
      size="small"
      bordered
      rowKey={(row, idx) => idx}
      summary={() => (
        <Table.Summary.Row className="group-total-row">
          <Table.Summary.Cell colSpan={columns.length - 1} index={0} className="summary-cell-right">
            Итого по группе:
          </Table.Summary.Cell>
          <Table.Summary.Cell index={columns.length - 1} align="right">
            {total ? total.toLocaleString() : ""}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
      className="detail-table-no-margin"
    />
  );
}


// Детализация по ячейке: шапка, таблица, итоги
function RepFinReportDetail({ detailData, onClose, detailType = 'put', vidName, expandedGroups, setExpandedGroups, selectedRowName = 'Всего' }) {

  const toggleType = (type) => {
    const key = String(type);
    const newExpanded = new Set(expandedGroups);
    if (newExpanded.has(key)) {
      newExpanded.delete(key);
    } else {
      newExpanded.add(key);
    }
    setExpandedGroups(newExpanded);
  };

  if (!detailData || !detailData.length) return null;

  const isGrouped = Array.isArray(detailData) && detailData[0]?.items;

  if (isGrouped) {
    const allItems = detailData.flatMap(g => g.items || g);
    const totalDetail = getTotal(allItems, detailType);

    const validGroups = detailData.filter(group => {
      const items = group.items || [group];
      return items.some(item => {
        if (detailType === 'exp') {
          return item.symaExp && item.symaExp !== 0;
        } else {
          return item.symaPut && item.symaPut !== 0;
        }
      });
    });

    if (validGroups.length === 0) {
      return (
        <div className="report-detail">
          <div className="detail-header">
            <Title level={4} className="detail-title detail-title-500">
              Подробно: {selectedRowName} - {vidName} - {detailType === 'exp' ? 'Возврат' : 'Приход'}
            </Title>
            <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
          </div>
        </div>
      );
    }

    return (
      <div className="report-detail">
        <div className="detail-header">
          <Title level={4} className="detail-title detail-title-bold">
            Подробно: {selectedRowName} - {vidName} - {detailType === 'exp' ? 'Возврат' : 'Приход'}
          </Title>
          <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
        </div>
        <div className="detail-content">
          <Collapse
            bordered={false}
            activeKey={Array.from(expandedGroups)}
            onChange={keys => setExpandedGroups(new Set(Array.isArray(keys) ? keys : [keys]))}
            expandIconPosition="start"
            className="collapse-detail"
          >
            {validGroups.map(group => {
              const items = group.items || [group];
              const groupTotal = getTotal(items, detailType);
              const expandKey = String(group.displayName || group.kassaName || group.periodName);
              return (
                <Panel
                  key={expandKey}
                  header={
                    <div className="panel-header panel-header-group">
                      <span className="type-label">{group.displayName || group.kassaName || group.periodName}</span>
                      <span className="type-count">({items.length})</span>
                      <span className="detail-group-total detail-group-total-main">{groupTotal ? groupTotal.toLocaleString() : ''}</span>
                    </div>
                  }
                  showArrow
                >
                  <DetailTable items={items} detailType={detailType} detailParams={{ vidName }} />
                </Panel>
              );
            })}
          </Collapse>
        </div>
        <div className="detail-overall-total">
          ИТОГО {totalDetail ? totalDetail.toLocaleString() : 0}
        </div>
      </div>
    );
  } else {
    const totalDetail = getTotal(detailData, detailType);
    const expandKey = String(selectedRowName);
    const isOpen = expandedGroups.size === 0 || expandedGroups.has(expandKey);

    return (
      <div className="report-detail">
        <div className="detail-header">
          <Title level={4} className="detail-title">
            Подробно: {selectedRowName} - {vidName} - {detailType === 'exp' ? 'Возврат' : 'Приход'}
          </Title>
          <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
        </div>
        <div className="detail-content">
          <Collapse
            bordered={false}
            activeKey={isOpen ? [expandKey] : []}
            onChange={keys => setExpandedGroups(new Set(Array.isArray(keys) ? keys : [keys]))}
            expandIconPosition="start"
            className="collapse-no-bg"
          >
            <Panel
              key={expandKey}
              header={
                <div className="panel-header panel-header-single">
                  <span className="type-label">{selectedRowName}</span>
                  <span className="type-count">({detailData.length})</span>
                  <span className="detail-group-total detail-group-total-green">{totalDetail ? totalDetail.toLocaleString() : ''}</span>
                </div>
              }
              showArrow
            >
              <DetailTable items={detailData} detailType={detailType} detailParams={{ vidName }} />
            </Panel>
          </Collapse>
        </div>
        <div className="detail-overall-total">
          ИТОГО {totalDetail ? totalDetail.toLocaleString() : 0}
        </div>
      </div>
    );
  }
}

export default RepFinReportDetail; 